module.exports = __webpack_public_path__ + "img/magazine-hiw-title.be95d29a.png";